// action
export const getAgreement = (state, val) => {
  state.agreements = val
}

export const getAgreementType = (state, temp) => {
  state.listType = temp
}

export const getAgreementStatus = (state, val) => {
  state.listStatus = val
}

export const detailAgreement = (state, val) => {
  state.agreement = val
}

export const getHistory = (state, val) => {
  state.histories = val
}
